const WorldpayUnreachable = () => {
  return (
    <div className="db-modal__content ac-animation--fade-in-from-right">
      <section className="db-section">
        <p className="db-question">Something went wrong</p>
        <p>
          Sorry, we were unable to reach our payment provider to take your
          reservation deposit. Please contact your product consultant for
          further instructions.
        </p>
      </section>
    </div>
  );
};

export default WorldpayUnreachable;
